import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Box, Button, IconButton, Popover } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import emoji from "emoji-dictionary";
import EmojiEmotionsOutlinedIcon from "@mui/icons-material/EmojiEmotionsOutlined";
import TooltipDark from "utils/TooltipDark";
import EmojiPopover from "./EmojiPopover";
import TaggingTextField from "./TaggingTextField";

export default function WinWireReplyEditInput({
  replyId,
  handleCancelEdit,
  handleSubmitEdit,
  inputValue,
  setInputValue,
  taggedUsers,
  setTaggedUsers,
}) {
  const [anchorPosition, setAnchorPosition] = useState(null);
  const { tagUserList } = useSelector((state) => state.hub);
  const [taggingPopoverOpen, setTaggingPopoverOpen] = useState(false);

  const handleOpenEmojiPopover = (event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setAnchorPosition({
      top: rect.top + window.scrollY,
      left: rect.left + window.scrollX,
    });
  };

  const handleCloseEmojiPopover = () => {
    setAnchorPosition(null);
  };

  const handleEmojiSelect = (emojiShortcode) => {
    const emojiNative = emoji.getUnicode(emojiShortcode);
    setInputValue((prev) => prev + emojiNative);
  };

  const handleKeyDown = (event) => {
    if (!taggingPopoverOpen) {
      if (event.key === "Enter" && event.shiftKey) {
        event.preventDefault();
        setInputValue((prev) => `${prev}\n`);
      } else if (event.key === "Enter") {
        event.preventDefault();
        handleSubmitEdit();
      }
    }
  };

  const popoverOpen = Boolean(anchorPosition);
  const id = popoverOpen ? `emoji-popover-${replyId}` : undefined;

  return (
    <Box className="reply-edit-container">
      <Box sx={{ position: "relative", width: "100%" }}>
        <TaggingTextField
          value={inputValue}
          handleInputChange={setInputValue}
          handleKeyDown={handleKeyDown}
          tagUserList={tagUserList}
          taggedUsers={taggedUsers}
          setTaggedUsers={setTaggedUsers}
          multiline
          rows={3}
          padding="0.5rem"
          backgroundColor="#1f1f1f"
          setTaggingPopoverOpen={setTaggingPopoverOpen}
        />
        <TooltipDark title="Add emoji" placement="top">
          <IconButton
            onClick={handleOpenEmojiPopover}
            sx={{
              position: "absolute",
              right: 8,
              bottom: 8,
              color: "#888",
            }}
          >
            <EmojiEmotionsOutlinedIcon />
          </IconButton>
        </TooltipDark>
      </Box>
      <Box display="flex">
        <TooltipDark title="Cancel" placement="top">
          <Button variant="contained" onClick={handleCancelEdit}>
            <CloseIcon />
          </Button>
        </TooltipDark>
        <TooltipDark title="Save" placement="top">
          <Button variant="contained" onClick={handleSubmitEdit}>
            <CheckIcon />
          </Button>
        </TooltipDark>
      </Box>
      <Popover
        id={id}
        open={popoverOpen}
        anchorReference="anchorPosition"
        anchorPosition={anchorPosition}
        onClose={handleCloseEmojiPopover}
        disableRestoreFocus
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        sx={{
          "& .MuiPopover-paper": {
            p: 0,
          },
        }}
      >
        <EmojiPopover
          handleReactionClick={handleEmojiSelect}
          handleCloseEmojiPopover={handleCloseEmojiPopover}
        />
      </Popover>
    </Box>
  );
}
